module.exports = "/static/Images/es/Zero.png";